import TP from 'typograf';

const _typograf = new TP({ locale: ['en-US'] });
const cache: Record<string, string> = {};

export default function typografFixText(str: string): string {
  if (str) {
    if (cache[str]) {
      return cache[str];
    } 
    else {
      const typografed = _typograf.execute(str);

      cache[str] = typografed;

      return typografed;
    }
  } 
  else {
    return str;
  }
}
